/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

var return_to = document.getElementById('return_to');
if(typeof(return_to) != 'undefined' && return_to != null){
	document.getElementById('return_to').value = getCookie('referrer');
}


$(document).ready(function() {
   $('.get_quick_step').on('click', function(e) {
     e.preventDefault()
      const parent = $(this).closest('.get_quick_step_outer');
       $(this).closest('.get_quick_step_outer').toggleClass('active_step');
      parent.find('.get_quick_step_content').slideToggle();
    });
  
  if(document.querySelector('.video_recipe')){
    document.querySelectorAll('.video_recipe').forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const playButton = wrapper.querySelector('.play-button');
  
    playButton.addEventListener('click', () => {
      video.play();
      video.setAttribute("controls", "controls")
      playButton.style.display = 'none';
    });
  
    video.addEventListener('pause', () => {
      video.removeAttribute("controls")
      playButton.style.display = 'flex';
    });
  
    video.addEventListener('play', () => {
      video.setAttribute("controls", "controls")
      playButton.style.display = 'none';
    });
  
      video.addEventListener('play', () => {
        document.querySelectorAll('video').forEach(otherVideo => {
          if (otherVideo !== video) {
            otherVideo.pause();
          }
        });
      });
    });
  }
  $('a[href="#cmp-revoke-consent-trigger"]').click(function(e){
    e.preventDefault();
    $('.cmp-revoke-consent').trigger('click');
  });
  
    
  
  if($('input[name="quantity"]').length > 0){
    $('input[name="quantity"]').attr('readonly','true');
  }
  
  if(getCookie('servicable_zone')){
    $('body').removeClass('disable_atc');
  }else{
    $('body').addClass('disable_atc');
  }  

  if(getParameterByName('cart')){
    $('.js-cart-trigger').trigger('click');
  }

/*
  $(document).on('submit', '#shopify-section-product-recommendations .js-product-form', function(e){
    e.preventDefault();
    alert('Hi');
  });
*/  
  
  // window.onbeforeunload=function(){return '.slider-links'}// product_category_from_name 

    
    function product_category_from_name(product_name){
      console.log('product_category_from_name');
      if(product_name.indexOf('Muesli') > -1 && product_name.indexOf('Nutri Drink') > -1 ){
        return 'Combo';
      }else if(product_name.indexOf('Granola') > -1 && product_name.indexOf('Oats') > -1 ){
        return 'Combo';
      }else if(product_name.indexOf('Granola') > -1 && product_name.indexOf('Muesli') > -1 ){
        return 'Combo';
      }else if(product_name.indexOf('Ragi Bites') > -1 && product_name.indexOf('Muesli') > -1 ){
        return 'Combo';
      }else if(product_name.indexOf('Muesli') > -1){
        return 'Millet Muesli';
      }else if(product_name.indexOf('Oats') > -1){
        return 'Oats';
      }else if(product_name.indexOf('Granola') > -1){
        return 'Granola';
      }else if(product_name.indexOf('Ragi Bites') > -1){
        return 'Ragi Bites';
      }else if(product_name.indexOf('Snack Mix') > -1){
        return 'Snack Mix';
      }else if(product_name.indexOf('Nutri Drink') > -1){
        return 'Nutri Drink';
      }else{
        return 'Other';
      }
    }
    
    // Search
    $('.js-mobile-draw-trigger, .secondary-nav .js-search-trigger').click(function(){
      window.adobeDataLayer.push({
        "event":"search_initiate",
        "eventInfo":{
            "eventName":"search_initiate"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName":"Search",
            "pageType":"Search",
            "language":"en_IN"
        }
      });
    });

    $(document).on('click', '.search__form-submit, .search-page__form-submit', function(e){
      window.adobeDataLayer.push({
        "event":"search",
        "eventInfo":{
            "eventName":"search"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text() 
        },
        "linkInfo":{
            "linkName":"Search:"+$(this).parents('form').find('input[name="q"]').val(),
            "linkPosition":"Search Box",
            "linkType":"Icon"
        },        
        "page":{
            "pageName":pageName,
            "pageType":pageType,
            "language":"en_IN"
        },
        "search":{
            "searchTerm":$(this).parents('form').find('input[name="q"]').val(),
            "autoSuggest":"no",
            "autoSuggestProduct":$(this).find('.title').text().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' ')
        }
      });
    });
  
    $(document).on('click', '.pshead.search a', function(e){
      window.adobeDataLayer.push({
        "event":"search",
        "eventInfo":{
            "eventName":"search"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text() 
        },
        "linkInfo":{
            "linkName":"See all results",
            "linkPosition":"Search Box",
            "linkType":"Button"
        },        
        "page":{
            "pageName":pageName,
            "pageType":pageType,
            "language":"en_IN"
        },
        "search":{
            "searchTerm":$(this).parents('form').find('input[name="q"]').val(),
            "autoSuggest":"no",
            "autoSuggestProduct":$(this).find('.title').text().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' ')
        }
      });
    });
  
    $(document).on('click', '.pred-item', function(e){
      
      var product_size = $(this).find('.title').text().split('|');
      var cprice = $(this).find('.cprice').text().replace('Rs.','').replace('.00','');
      var price = $(this).find('.price').text().replace('Rs.','').replace('.00','');
      var discount = $.trim(cprice-price);
      var discount_percentage = $.trim(Math.round(parseFloat(((cprice-price)/cprice)*100).toFixed(2)));
      if(discount == 0){ discount = ''; }
      if(discount_percentage == 0){ discount_percentage = ''; }
      // alert(cprice);
      if(cprice == '0'){ cprice = price; }
      window.adobeDataLayer.push({
        "event":"search",
        "eventInfo":{
            "eventName":"search"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "linkInfo":{
            "linkName":"Search Product",
            "linkPosition":"Search Box",
            "linkType":"Link"
        },        
        "page":{
            "pageName":pageName,
            "pageType":pageType,
            "language":"en_IN"
        },
        "search":{
            "searchTerm":$(this).parents('form').find('input[name="q"]').val(),
            "autoSuggest":"yes",
            "autoSuggestProduct":$(this).find('.title').text().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' ')
        },
        "product": [{
          "productName":$(this).find('.title').text().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":product_category_from_name($(this).find('.title').text()),
          "productId":""+$(this).find('.pid').text(),
          "productSize":product_size[1].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '').replace('+','').replaceAll(' ',''),
          "productPrice":""+$.trim(cprice),
          "productSalePrice":""+$.trim(price),
          "productDiscountedPrice":""+discount,
          "discountPercentage":""+discount_percentage,
          "productQuantity":"1",
          "productInStock":"Yes",
          "productVariantId": ""
      }]
      });
    });
  

    function adobe_product_item_click($this){

      var linkPosition = pageType;
      var productPosition = '';
      var linkType = 'Image';
      // alert(event.target.tagName);
      if(pageType == 'Home'){
        productPosition = $this.parents('.slick-slide').index()+1;
        linkPosition = 'Best Sellers';
      }
      if(pageType == 'PLP' || pageType == 'PDP'){
        productPosition = $this.parents('.o-layout__item').index()+1;

        if($this.parents('section').hasClass('section--related-products')){
          linkPosition = 'More Goodness';
        }

        if($this.parents('#shopify-section-product-recommendations').length){
          linkPosition = 'Frequently Purchased Together';
        }

      }
      if(($('body').attr('id').indexOf('limited') > -1) && ($('body').attr('id').indexOf('time') > -1)){
        linkPosition = 'Limited Time Deals';
        productPosition = $this.parents('.o-layout__item').index()+1;
      }

      /*
      if($('body')hasClass('template-search')){
        linkPosition = 'Limited Time Deals';
        productPosition = $this.parents('.o-layout__item').index()+1;
      }
      */
      
      var title 			= $this.parents('.product-item').find('.product__title').text();
      var price 			= $this.parents('.product-item').find('.product__price-price').find('.money').text();
      if($this.parents('.product-item').find('.product__price-cross').find('.money').text()){
        var price_compare 	= $this.parents('.product-item').find('.product__price-cross').find('.money').text();

        var discount = $.trim(price_compare.replace('Rs.','')) - $.trim(price.replace('Rs.',''));
        // if(discount <= 0){ discount = ''; }

        var discountPercentage = Math.round(parseFloat((discount/$.trim(price_compare.replace('Rs.','')))*100).toFixed(2));
        // if(discountPercentage <= 0){ discountPercentage = ''; }
        
      }else{
        var price_compare 	= price;
        var discount = '';
        var discountPercentage = '';
      }
      
      var pid = $this.parents('.product-item').find('.pid').text();
      var vid = $this.parents('.product-item').find('.vid').text();
      var product_size = $this.parents('.product-item').find('.psize').text();
      // alert(pid);
      // pid 				   = $.trim(pid.replace('product_form_',''));
      // alert(pid);
      var category_name	= $this.parents('.product-item').find('#collections-'+pid).text();
      
      // alert(category_name);

      var btn_text = $this.parents('.product-item').find('.product-btn__btn').text();

      /*
      if($this.parents('.slick-slide').index() > -1){
        var productPosition = $this.parents('.slick-slide').index()+1;
      }else{ 
        var productPosition = $this.parents('.product-item').index()+1;
      }
      */

      window.adobeDataLayer.push({
        "event":"product_click",
        "eventInfo":{
            "eventName":"product_click"
        },
        "linkInfo":{
            "linkName":"Product Card",
            "linkPosition":linkPosition,
            "linkType":linkType
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName": pageName,
            "pageType": pageType,
            "language": "en_IN",
            "productPosition": ""+productPosition
        },
        "product":[{ 
          "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":category_name.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productId":pid,
          "productSize":product_size.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productPrice":""+$.trim(price_compare.replace('Rs.','').replace('.00','').replaceAll(',',''))+"",
          "productSalePrice":""+$.trim(price.replace('Rs.','').replace('.00','').replaceAll(',',''))+"",
          "productDiscountedPrice":""+discount,
          "discountPercentage":""+discountPercentage,
          "productQuantity":"1",
          "productInStock": (btn_text.indexOf('Sold Out') > -1)?'No':'Yes',
          "productVariantId": vid
        }]
      });
      
    }

    function adobe_cart_item_click($this){
      var title 			= $this.parents('.ajaxcart__row').find('.ajaxcart__product-name').text();
      var price 			= $this.parents('.ajaxcart__row').find('.ajaxcart-item__price').find('.money').text();
      if($this.parents('.ajaxcart__row').find('.product__price-cross').find('.money').text()){
        var price_compare 	= $this.parents('.ajaxcart__row').find('.product__price-cross').find('.money').text();
        var discount = $.trim(price_compare.replace('Rs.','')) - $.trim(price.replace('Rs.',''));
        // if(discount < 0){ discount = 0; }
      }else{
        var price_compare 	= price;
        var discount = '';
      }
      
      // var pid   			= $this.parents('.ajaxcart__row').find('form').attr('id');
      var pid = $this.parents('.ajaxcart__row').find('.pid').text();
      // alert(pid);
    
      // pid 				   = $.trim(pid.replace('product_form_',''));
      pid = pid.split(':');
      vid = pid[0];
      // alert(pid);
      // alert(pid);

      
      var product_size = title.split('|');
      // alert('Size: '+product_size[1]);
      
      // var category_name	= $this.parents('.ajaxcart__row').find('#collections-'+pid).text();
      // alert(category_name);
      
      var productPosition = $this.parents('.ajaxcart__product').index()+1;
 
      var btn_text = $this.parents('.ajaxcart__row').find('.product-btn__btn').text();
      
      window.adobeDataLayer.push({
        "event":"product_click",
        "eventInfo":{
            "eventName":"product_click"
        },
        "linkInfo":{
            "linkName":"Product Card",
            "linkPosition":"Cart Overlay",
            "linkType":"Image"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName": "Cart Overlay",
            "pageType": "Cart",
            "language": "en_IN",
            "productPosition": ""+productPosition
        },
        "product":[{
          "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":product_category_from_name(title),
          "productId":"",
          "productSize":product_size[1].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productPrice":""+$.trim(price_compare.replace('Rs.','').replace('.00','').replaceAll(',','').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ')),
          "productSalePrice":""+$.trim(price_compare.replace('Rs.','').replace('.00','').replaceAll(',','').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ')),
          "productDiscountedPrice":""+discount,
          "discountPercentage":"",
          "productQuantity":""+$this.parents('.ajaxcart__row').find('[name="updates[]"]').val(),
          "productInStock": "Yes",
          "productVariantId": vid
        }]
      });
      
    }


  function adobe_upsell_item_click($this){
      var title 			= $this.parents('.upsell-product').find('h3').text();
      var price 			= $this.parents('.upsell-product').find('.price').find('.money').text();
      if($this.parents('.upsell-product').find('.product__price-cross').find('.money').text()){
        var price_compare 	= $this.parents('.upsell-product').find('.product__price-cross').find('.money').text();
      }else{
        var price_compare 	= price;
      }
      
      // var pid   			= $this.parents('.upsell-product').find('form').attr('id');
      var pid = $this.parents('.upsell-product-wrap').data('product');
      var vid = $this.parents('.upsell-product-wrap').data('variant');
      var product_size = title.split('|');
        product_size = product_size[1];
        if(product_size){
          product_size = $.trim(product_size.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '));
        }else{
          product_size = "";
        }
    
      // alert(pid);
      // pid 				   = $.trim(pid.replace('product_form_',''));
      // alert(pid);
      var category_name	= $this.parents('.upsell-product').find('#collections-'+pid).text();
      // alert(category_name);
      var cprice = $.trim(price_compare.replace('Rs.',''));
      var price = $.trim(price.replace('Rs.',''));
      // alert(cprice);
      if(cprice || cprice == "0"){
        var discount = cprice - price;
      }else{
        cprice = price;
        var discount = "0";
      }

      var productPosition = $this.parents('.upsell-product-wrap').index()+1;
    
      // var btn_text = $this.parents('.upsell-product').find('.product-btn__btn').text();
      
      window.adobeDataLayer.push({
        "event":"product_click",
        "eventInfo":{
            "eventName":"product_click"
        },
        "linkInfo":{
            "linkName":"Product Card",
            "linkPosition":"Frequently bought together",
            "linkType":"Link"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName": "Cart Overlay",
            "pageType": "Cart",
            "language": "en_IN",
            "productPosition": ""+productPosition
        },
        "product":[{
          "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":product_category_from_name(title),
          "productId":""+pid,
          "productSize":$.trim(product_size.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' ')),
          "productSalePrice":""+price,
          "productPrice":""+cprice,
          "productDiscountedPrice":""+discount,
          "discountPercentage":""+Math.round(parseFloat((discount/$.trim(price_compare.replace('Rs.','')))*100).toFixed(2))+"",
          "productQuantity":"1",
          "productInStock": "Yes",
          "productVariantId": ""+vid
        }]
      });
      
    }


    function adobe_upsell_item_atc($this){
      var title 			= $this.parents('.upsell-product').find('h3').text();
      var price 			= $this.parents('.upsell-product').find('.price').find('.money').text();
      if($this.parents('.upsell-product').find('.product__price-cross').find('.money').text()){
        var price_compare 	= $this.parents('.upsell-product').find('.product__price-cross').find('.money').text();
      }else{
        var price_compare 	= price;
      }
      
      // var pid   			= $this.parents('.upsell-product').find('form').attr('id');
      var pid = $this.parents('.upsell-product-wrap').data('product');
      var vid = $this.parents('.upsell-product-wrap').data('variant');
      var product_size = title.split('|');
      product_size = product_size[1];
      // console.log(product_size);
      if(product_size){
        product_size = $.trim(product_size.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll(' ',''));
      }else{
        product_size = "";
      }
      // console.log(product_size);
      // alert(pid);
      // pid 				   = $.trim(pid.replace('product_form_',''));
      // alert(pid);
      var category_name	= $this.parents('.upsell-product').find('#collections-'+pid).text();
      // alert(category_name);
      var discount = $.trim(price_compare.replace('Rs.','')) - $.trim(price.replace('Rs.',''));
      if(discount < 0){ discount = 0; }
      var productPosition = $this.parents('.upsell-product-wrap').index()+1;
      // alert($this.parents('.upsell-product-wrap').index());

      // var btn_text = $this.parents('.upsell-product').find('.product-btn__btn').text();'
      window.adobeDataLayer.push({
        "event":"Cart",
        "eventInfo":{
            "eventName":"Cart"
        },
        "linkInfo":{
            "linkName":"Add to Cart",
            // "linkPosition":"Cart Overlay",
            "linkPosition":"Frequently bought together",
            "linkType":"Button"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName": "Cart Overlay",
            "pageType": "Cart",
            "language": "en_IN",
            "productPosition": ""+productPosition
        },
        "product":[{
          "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":category_name.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productId":""+pid+"",
          "productSize":""+product_size,
          "productSalePrice":""+$.trim(price.replace('Rs.','').replace('.00','').replaceAll(',','')),
          "productPrice":""+$.trim(price_compare.replace('Rs.','').replace('.00','').replaceAll(',','')),
          "productDiscountedPrice":""+discount,
          "discountPercentage":""+Math.round(parseFloat((discount/$.trim(price_compare.replace('Rs.','')))*100).toFixed(2))+"",
          "productQuantity":"1",
          "productInStock": "Yes",
          "productVariantId": ""+vid+""
        }]
      });
      
    }
  

    function adobe_product_item_atc($this){
      // alert(pageType);
      var linkPosition = pageType;
      var productPosition = '';
      if(pageType == 'Home'){
        productPosition = $this.parents('.slick-slide').index()+1;
        linkPosition = 'Best Sellers';
      }
      if(pageType == 'PLP'){
        productPosition = $this.parents('.o-layout__item').index()+1;
        linkPosition = 'Body';
      }
      if(pageType == 'PDP'){
        productPosition = $this.parents('.o-layout__item').index()+1;
        linkPosition = $this.parents('.container').find('.section__title-text').text();
      }
      if(($('body').attr('id').indexOf('limited') > -1) && ($('body').attr('id').indexOf('time') > -1)){
        linkPosition = 'Limited Time Deals';
        productPosition = $this.parents('.o-layout__item').index()+1;
      }

      if($this.parents('section').hasClass('section--related-products')){
          linkPosition = 'More Goodness';
      }

      if($this.parents('#shopify-section-product-recommendations').length){
          linkPosition = 'Frequently Purchased Together';
      }

      var title 			= $this.parents('.product-item').find('.product__title').text();
      var price 			= $this.parents('.product-item').find('.product__price-price').find('.money').text();
      if($this.parents('.product-item').find('.product__price-cross').find('.money').text()){
        var price_compare 	= $this.parents('.product-item').find('.product__price-cross').find('.money').text();
      }else{
        var price_compare 	= price;
      }
      
      // var pid   			= $this.parents('.product-item').find('form').attr('id');
      var pid = $this.parents('.product-item').find('.pid').text();
      var vid = $this.parents('.product-item').find('.vid').text();
      var product_size = $this.parents('.product-item').find('.psize').text();
      // alert(pid);
      // pid 				   = $.trim(pid.replace('product_form_',''));
      // alert(pid);
      
      var category_name	= $this.parents('.product-item').find('#collections-'+pid).text();
      // alert(category_name);
      var discount = $.trim(price_compare.replace('Rs.','').replaceAll(',','')) - $.trim(price.replace('Rs.','').replaceAll(',',''));
      if(discount <= 0){
        discount = '';
        var discountPercentage = '';
      }else{
        var discountPercentage = Math.round(parseFloat((discount/$.trim(price_compare.replace('Rs.','').replaceAll(',','')))*100).toFixed(2));
      }

      var btn_text = $this.parents('.product-item').find('.product-btn__btn').text();
      
      window.adobeDataLayer.push({
        "event":"Cart",
        "eventInfo":{
            "eventName":"Cart"
        },
        "linkInfo":{
            "linkName":"Add to Cart",
            "linkPosition":""+linkPosition,
            "linkType":"Button"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName": pageName,
            "pageType": pageType,
            "language": "en_IN",
            "productPosition": ""+productPosition
        },
        "product":[{
          "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":category_name.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productId":pid,
          "productSize":""+$.trim(product_size.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll(' ','')),
          "productPrice":""+$.trim(price_compare.replace('Rs.','').replace('.00','').replaceAll(',','')),
          "productSalePrice":""+$.trim(price.replace('Rs.','').replace('.00','').replaceAll(',','')),
          "productDiscountedPrice":""+discount,
          "discountPercentage":""+discountPercentage,
          "productQuantity":"1",
          "productInStock": (btn_text.indexOf('Sold Out') > -1)?'No':'Yes',
          "productVariantId": vid
        }]
      });
      
    }


    function adobe_product_atc($this){
      var title 			= $this.parents('.product-single__bottom').find('.product-single__title-text').text();
      var price 			= $this.parents('.product-single__bottom').find('.product-single__price-number').find('.money').text();
      if($this.parents('.product-single__bottom').find('.product-single__price-compare').find('.money').text()){
        var price_compare 	= $this.parents('.product-single__bottom').find('.product-single__price-compare').find('.money').text();
      }else{
        var price_compare 	= price;
      }
      var pid   		= $this.parents('.product-single__bottom').find('.product-single__form').attr('id');
      var vid   	    = $this.parents('.product-single__bottom').find('.vid').text();
      var product_size  = $this.parents('.product-single__bottom').find('.psize').text();
      pid 				= $.trim(pid.replace('js-product-form--',''))
      var category_name	= $this.parents('.product-single__bottom').find('.collection').text();

      var discount  		= $.trim(price_compare.replace('Rs.','')).replaceAll(',','') - $.trim(price.replace('Rs.','').replaceAll(',',''));
      if(discount < 0){ discount = 0; }
      
      window.adobeDataLayer.push({
        "event":"Cart",
        "eventInfo":{
            "eventName":"Cart"
        },
        "linkInfo":{
            "linkName":"Add to Cart",
            "linkPosition":"Body",
            "linkType":"Button"
        },
        "custData":{
            "custId":$('#cid').text(),
            "loginStatus":$('#lstatus').text()
        },
        "page":{
            "pageName": pageName,
            "pageType": pageType,
            "language": "en_IN"
        },
        "product":[{
          "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productCategory":category_name.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
          "productId":pid,
          "productSize":""+$.trim(product_size.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll(' ','')),
          "productPrice":""+$.trim(price_compare.replace('Rs.','').replace('.00','').replaceAll(',','')),
          "productSalePrice":""+$.trim(price.replace('Rs.','').replace('.00','').replaceAll(',','')),
          "productDiscountedPrice":""+discount,
          "discountPercentage":""+Math.round(parseFloat((discount/$.trim(price_compare.replace('Rs.','').replaceAll(',','')))*100).toFixed(2)),
          "productQuantity":$('#Quantity').val(),
          "productInStock": "Yes",
          "productVariantId": vid
        }]
      });
      
    }
  
    function adobe_checkout_btn(){
      // console.log('HI 2');
      if(getCookie('checkout_clicked') != 1){
        // console.log('HI');
        window.adobeDataLayer.push({
            "event":"checkout",
            "eventInfo":{
                "eventName":"checkout"
             },
             "linkInfo":{
                "linkName":"Checkout",
                "linkPosition":"Body",
                "linkType":"Button"
              },
             "custData":{
                "custId":$('#cid').text(),
                "loginStatus":$('#lstatus').text()
          },
          "page":{
              "pageName": 'Cart Overlay',
              "pageType": 'Cart',
              "language": "en_IN"
          },
          "product": JSON.parse($('#ajax_items').text()),
           "orderSummary":{
               "totalProductPrice":$.trim($('#CartContainer').find('.ajaxcart__footer-total').find('.money').text().replace('Rs.','').replace('.00','').replaceAll(',','')),
               "totalProductSalePrice":$.trim($('#CartContainer').find('.ajaxcart__footer-total').find('.money').text().replace('Rs.','').replace('.00','').replaceAll(',','')),
               "totalOrderPrice":$.trim($('#CartContainer').find('.ajaxcart__footer-total').find('.money').text().replace('Rs.','').replace('.00','').replaceAll(',',''))
           }
        });
        setCookie('checkout_clicked', 1, 0.0005);
      }
    }

    function adobe_cart(){
    // console.log(JSON.parse($('#ajax_items').text()));
     window.adobeDataLayer.push({
          "event":"landed",
          "eventInfo":{
              "eventName":"landed"
          },
          "custData":{
              "custId":$('#cid').text(),
              "loginStatus":$('#lstatus').text()
          },
          "page":{ 
              "pageName": "Cart Overlay",
              "pageType": "Cart",
              "language":"en_IN"
          },
          "product": JSON.parse($('#ajax_items').text()),
          "orderSummary":{
              "totalProductPrice":$.trim($('#CartContainer').find('.ajaxcart__footer-total').find('.money').text().replace('Rs.','').replace('.00','').replaceAll(',','')),
              "totalProductSalePrice":$.trim($('#CartContainer').find('.ajaxcart__footer-total').find('.money').text().replace('Rs.','').replace('.00','').replaceAll(',','')),
              "totalOrderPrice":$.trim($('#CartContainer').find('.ajaxcart__footer-total').find('.money').text().replace('Rs.','').replace('.00','').replaceAll(',',''))
          }
        });
    }

    function adobe_empty_cart(){
    // console.log(JSON.parse($('#ajax_items').text()));
     window.adobeDataLayer.push({
          "event":"landed",
          "eventInfo":{
              "eventName":"landed"
          },
          "custData":{
              "custId":$('#cid').text(),
              "loginStatus":$('#lstatus').text()
          },
          "page":{ 
              "pageName": "Empty Cart Overlay",
              "pageType": "Cart",
              "language":"en_IN"
          }
        });
    }


    function ajax_cart_increase($this){
        var title 			= $this.parents('.ajaxcart__row').find('.ajaxcart__product-name').text();
    	var price 			= $this.parents('.ajaxcart__row').find('.ajaxcart-item__price').find('.money').text();
    	if($this.parents('.ajaxcart__row').find('.product__price-cross').find('.money').text()){
    		var price_compare 	= $this.parents('.ajaxcart__row').find('.product__price-cross').find('.money').text();
    	}else{
    		var price_compare 	= price;
    	}
    
    	var pid = $this.parents('.ajaxcart__row').find('.pid').text();
    	// alert(pid);
    
    	// pid 				   = $.trim(pid.replace('product_form_',''));
    	pid = pid.split(':');
    	vid = pid[0];
    	// alert(pid);
    	// alert(pid);
    
    
    	var product_size = title.split('|');
        if(product_size[1]){
          product_size = product_size[1].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '').replaceAll('+','');
        }else{
          product_size = "";
        }
        var price = $.trim(price_compare.replace('Rs.','').replace('.00','').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replaceAll(',',''));
        var cprice = $.trim(price.replace('Rs.','').replace('.00','').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replaceAll(',',''));
        var qty = parseInt($this.parents('.ajaxcart__row').find('[name="updates[]"]').val());
    	
    	window.adobeDataLayer.push({
    	    "event":"Cart",
    	    "eventInfo":{
    	        "eventName":"Cart"
    	     },
    	     "linkInfo":{
    	        "linkName":"Add to Cart",
    	        "linkPosition":"Cart Overlay",
    	        "linkType":"Button"
    	      },
    	     "custData":{
    	        "custId":$('#cid').text(),
    			"loginStatus":$('#lstatus').text()
    	     },
    	     "page":{
    	        "pageName": 'Cart Overlay',
    			"pageType": 'Cart',
    			"language": "en_IN",
    	       "productPosition": $this.parents('.ajaxcart__product').index()+1+""
    	     },
    	     "product":[{
    			  "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replaceAll('+','').replaceAll('  ',' '),
    			  "productCategory":product_category_from_name(title),
    			  "productId":pid[0],
    			  "productSize":product_size,
    			  "productSalePrice":""+price/qty,
    			  "productPrice":""+cprice/qty,
                  "productDiscountedPrice":"",
    			  "discountPercentage":"",
    			  "productQuantity":"1",
    			  "productInStock": "Yes",
    			  "productVariantId": vid
    			}]
    	});
      
    }


    function ajax_cart_reduce($this){
    	var title 			= $this.parents('.ajaxcart__row').find('.ajaxcart__product-name').text();
    	var price 			= $this.parents('.ajaxcart__row').find('.ajaxcart-item__price').find('.money').text();
    	if($this.parents('.ajaxcart__row').find('.product__price-cross').find('.money').text()){
    		var price_compare 	= $this.parents('.ajaxcart__row').find('.product__price-cross').find('.money').text();
    	}else{
    		var price_compare 	= price;
    	}
    
    	var pid = $this.parents('.ajaxcart__row').find('.pid').text();
    	// alert(pid);
    
    	// pid 				   = $.trim(pid.replace('product_form_',''));
    	pid = pid.split(':');
    	vid = pid[0];
    	// alert(pid);
    
    	var product_size = title.split('|');
        if(product_size[1]){
          product_size = product_size[1].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '').replace('+','');
        }else{
          product_size = "";
        }
      
        var price = $.trim(price_compare.replace('Rs.','').replace('.00','').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replaceAll(',',''));
        var cprice = $.trim(price.replace('Rs.','').replace('.00','').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replaceAll(',',''));
        var qty = parseInt($this.parents('.ajaxcart__row').find('[name="updates[]"]').val());
    	
    	window.adobeDataLayer.push({
    	    "event":"Cart",
    	    "eventInfo":{
    	        "eventName":"Cart"
    	     },
    	     "linkInfo":{
    	        "linkName":"Remove From Cart",
    	        "linkPosition":"Cart Overlay",
    	        "linkType":"Button"
    	      },
    	     "custData":{
    	        "custId":$('#cid').text(),
    			"loginStatus":$('#lstatus').text()
    	     },
    	     "page":{
    	        "pageName": 'Cart Overlay',
    			"pageType": 'Cart',
    			"language": "en_IN",
                "productPosition": $this.parents('.ajaxcart__product').index()+1+""
    	     },
    	     "product":[{
    			  "productName":title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ').replace('+','').replaceAll('  ',' '),
    			  "productCategory":product_category_from_name(title),
    			  "productId":pid[0],
    			  "productSize":product_size,
    			  "productSalePrice":""+price/qty,
    			  "productPrice":""+cprice/qty,
                  "productDiscountedPrice":"",
    			  "discountPercentage":"",
    			  "productQuantity":"1",
    			  "productInStock": "Yes",
    			  "productVariantId": vid
    			}]
    	});

        setTimeout(function(){
          console.log('Last Item removed');
          if($('#CartCount').text() == '0'){
            adobe_empty_cart()
          }
        }, 2000); 
    
    }

  
    
    $(document).on('click', '.product-item a', function(e){ adobe_product_item_click($(this)) });
    $(document).on('click', '.ajaxcart__product a', function(e){ adobe_cart_item_click($(this)) });
    $(document).on('click', '.upsell-product a', function(e){ adobe_upsell_item_click($(this)) });
    $(document).on('click', '.upsell-product button', function(e){ adobe_upsell_item_atc($(this)) });
  
    $(document).on('click', '.product-item .js-product-add', function(e){ adobe_product_item_atc($(this)); setTimeout(function(){ adobe_cart() }, 2000); });
    $(document).on('click', '.js-product-single-box .js-product-add', function(e){ adobe_product_atc($(this)); setTimeout(function(){ adobe_cart() }, 2000); });

    
    $(document).on('click', '[name="checkout"]', function(e) {
      adobe_checkout_btn();
    });
    $(document).on('click', '.js-cart-trigger', function(e) {
      if($('#CartCount').text() == '0'){
        adobe_empty_cart()
      }else{
        setTimeout(function(){ adobe_cart() }, 2000); 
      }
    });

    $(document).on('click', '.ajaxcart__qty--plus', function(e) { ajax_cart_increase($(this)) });

    $(document).on('click', '.ajaxcart__qty--minus', function(e) { ajax_cart_reduce($(this)) });getCRMDetails();
  initOwlCarousel();
  applyProductName();
  updateShippingBarRate();
  
    

  
  
  if($('[data-upsell-products]').length) {
    
    UpsellHandler();

    // Qty Box Actions
    $(document).on('click', '.ajaxcart__qty-adjust', function() {
      console.log('Adjust');
      setTimeout(function(){
        UpsellHandler();
      }, 500);
    });

    // Show upsells when product is added
    $(document).on('click', '.js-product-add', function() {
      $('.upsell_wrap').show();
    });
    
    
    // ATC action of upsell products
    $(document).on('click', '.upsell_atc', function() {

      var $self = $(this);
      var Variant = $self.parents('.upsell-product').find('[name="upsell-variant"]').val();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data : {
          id: parseInt(Variant),
          quantity: 1
        },
        dataType: 'json',
        success: function(data) {
          ajaxCart.load();
          UpsellHandler();
        }
      })           
    });


    function UpsellHandler(){

      var upsellProducts = $('#upsell-products').data('upsell-products');
      upsellProducts = upsellProducts.split(',');

      if(upsellProducts.length) {
        var asyncRequest = [];
        var addedUpsellCount = 0;
        var upsellHolder = $('#upsell-products');

              // To remove Snack mix combo (fixed first item), remove line number 944 to 988 and uncomment line 998
              
              //var productUrl = '/products/snack-mix-superfood-delight-200g-berry-nutty-delight-200g-protein-punch-200g-combo-600g.js';
              var productUrl = '/products/ragi-bites-choco-fills-1000g-ragi-bites-no-maida-choco-375g-1375g.js';
              asyncRequest.push(
                $.getJSON(productUrl, function(response) {
                  var html = '';
                  var product = response;  
                  var product_title = product.title;

                  if(!product.available){ return; }

                  if(product.featured_image) {
                    var om = product.featured_image,
                        pi = om.split(".");
                    pi[pi.length-2] = pi[pi.length-2] + "_150x";
                    var product_image = pi.join('.');
                  } else {
                    var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
                  }

                  html += '<div class="upsell-product-wrap" data-product="' + product.id + '" data-variant="' + product.variants[0].id + '">';
                  html += '<div class="upsell-product">';
                  html += '<div class="upsell-image">';
                  html += '<img class="lazyload" data-src="' + product_image + '" alt="' + product.title + '" />';
                  html += '</div>';
                  html += '<h3>';
                  html += '<a href="' + product.url + '">' + product_title.trim() + '</a>';      
                  html += '</h3>';
                  html += '<input type="hidden" name="upsell-variant" value="' + product.variants[0].id + '" />';
                  html += '<div class="upsell-button-wrap">';
                  html += '<p class="price"><span class="money">Rs. ' + product.price / 100 + '</span></p>';
                  html += '<p class="product__price-cross" style="display: none;"><span class="money">Rs. ' + product.compare_at_price / 100 + '</span></p>';
                  html += '<button type="button" class="c-btn upsell_atc">';
                  html += '+';
                  html += '</button>';
                  html += '</div>';
                  html += '</div>';
                  html += '</div>';

                  upsellHolder.append(html);
                })
                .fail(function() {
                  $('.upsell_wrap').hide();
                })
              );    
        

        

        
        $.getJSON('/cart.js', function(cart) {
          for(var i=0; i<upsellProducts.length; i++) {
            var showProduct = true;            
            var upsellProduct = upsellProducts[i];

            // upsellHolder.html('');

            for(var j=0; j<cart.items.length; j++) {
              var cartItem = cart.items[j];

              if(upsellProduct == cartItem.handle) {
                showProduct = false;
                addedUpsellCount = addedUpsellCount + 1;
              }
            }
            
            if(showProduct) {
              var productUrl = '/products/' + upsellProduct + '.js';

              asyncRequest.push(
                $.getJSON(productUrl, function(response) {
                  var html = '';
                  var product = response;  
                  var product_title = product.title;

                  if(!product.available){ return; }

                  if(product.featured_image) {
                    var om = product.featured_image,
                        pi = om.split(".");
                    pi[pi.length-2] = pi[pi.length-2] + "_150x";
                    var product_image = pi.join('.');
                  } else {
                    var product_image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-50-3d8cc48bd078edcd544c8d60f929ed2d8800a3fc52e0f602e84b1767e392bfcd_180x.gif';
                  }

                  html += '<div class="upsell-product-wrap" data-product="' + product.id + '" data-variant="' + product.variants[0].id + '">';
                  html += '<div class="upsell-product">';
                  html += '<div class="upsell-image">';
                  html += '<img class="lazyload" data-src="' + product_image + '" alt="' + product.title + '" />';
                  html += '</div>';
                  html += '<h3>';
                  html += '<a href="' + product.url + '">' + product_title.trim() + '</a>';      
                  html += '</h3>';
                  html += '<input type="hidden" name="upsell-variant" value="' + product.variants[0].id + '" />';
                  html += '<div class="upsell-button-wrap">';
                  html += '<p class="price"><span class="money">Rs. ' + product.price / 100 + '</span></p>';
                  html += '<p class="product__price-cross" style="display: none;"><span class="money">Rs. ' + product.compare_at_price / 100 + '</span></p>';
                  html += '<button type="button" class="c-btn upsell_atc">';
                  html += '+';
                  html += '</button>';
                  html += '</div>';
                  html += '</div>';
                  html += '</div>';

                  upsellHolder.append(html);
                })
                .fail(function() {
                  $('.upsell_wrap').hide();
                })
              );

            }        
          }


          $.when.apply(null, asyncRequest).done( function() {
            if(upsellHolder.is(':empty')) {
              $('.upsell_wrap').hide();
            } else {
              if($('#CartCount').text() != '0'){
                $('.upsell_wrap').show();
              }
            }
          }); 

          if(upsellProducts.length === addedUpsellCount) {
            $('.upsell_wrap').hide();
          }
        })
      } 

      // Show/hide Upsell based on Cart Value
      setTimeout(function(){
        if($('#CartCount').text() =='0'){
          $('.upsell_wrap').hide();
        }else{
          $('.upsell_wrap').show();
        }
      }, 500);


    }
  }


  

  

  
  
  
  
  
    
  
    $(function() {

        var currentAjaxRequest = null;
        var searchForms = $('form[action="/search"]').each(function() {
          var input = $(this).find('input[name="q"]');
          $('<ul class="search-results"></ul>').appendTo($(this));

          input.attr('autocomplete', 'off').bind('keyup change', function() {

            var term = $(this).val();
            var form = $(this).closest('form');
            var searchURL = '/search?type=product&q=' + term;
            var resultsList = form.find('.search-results');

            if (term.length > 0 && term != $(this).attr('data-old-term')) {

              $(this).attr('data-old-term', term);

              if (currentAjaxRequest != null) currentAjaxRequest.abort();
              var  ajaxData = {
                "resources": {
                  "type": 'product,collection',
                  "limit": 6,
                  "options": {
                    "unavailable_products": 'last',
                    "fields": 'title,product_type,variants.title'
                  }
                }
              };
              var url2 = '&resources[type]=product,collection'
              currentAjaxRequest = $.getJSON({
                'url':  "/search/suggest.json?q=" + term + url2,
                'type': 'GET',
                'dataType': 'json',
                data: ajaxData,
                'success': function(data) {
                  resultsList.empty();
                  if(data.resources.results.products.length == 0) {
                    resultsList.hide();
                  } else {
                    resultsList.append('<li class="pshead">Products</li>');
                    $.each(data.resources.results.products, function(index, item) {
                      var link = $('<a></a>').attr('href', item.url);
                      var image_url = item.featured_image.url;
                      if (image_url !== null) {
                        var extension =   image_url.split('.').pop();
                        var image =  image_url.replace('.' + extension, '_thumb') + '.' + extension;
                      } else {
                        var image = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_40x.gif'
                      }
                      link.append('<div class="thumbnail"><img src="' + image  + '" /></div>');
                      link.append('<div class="content"><span class="title">' + item.title + '</span><span class="price">Rs. ' + item.price + '</span></div>');
                      link.append('<div class="cprice" style="display:none">'+item.compare_at_price_min+'</div>');
                      link.append('<div class="pid" style="display:none">'+item.id+'</div>');
                      link.wrap('<li class="pred-item"></li>');
                      resultsList.append(link.parent());
                    });
                    /*
                    if(data.resources.results.collections.length == 0) {
                    } else {
                      resultsList.append('<li class="pshead col">Collections</li>');
                      $.each(data.resources.results.collections, function(index, item) {
                        var link = $('<a></a>').attr('href', item.url);
                        link.append('<span>' + item.title + '</span>')
                        link.wrap('<li class="pred-item pred-search-tit"></li>');
                        resultsList.append(link.parent());
                      });
                    }
                    */
                    resultsList.append('<li class="pshead search"><a href="' + searchURL + '">See all results</a></li>');

                    resultsList.fadeIn(200);
                    
                    // webengage.track("Product Searched", { "Search Keyword" : term, "Item Count" : data.resources.results.products.length });

                  }
                }
              });
            }
          });
        });


        $('body').bind('click', function(){
          $('.search-results').hide();
        });

    });   
 

  
  
   
  
  


  // Fixed ATC
  if($(window).width() < 981 && $('.qty-atc-wrap').length > 0){
    $(window).scroll(function(){ 	
      if(window.pageYOffset > $('.product-single__box').offset().top + $('.product-single__box').height() - $('.free-shipping-wrapper').height() - 62){
        $('.qty-atc-wrap').addClass("sticky");
        $('.qty-atc-wrap-spacer').css({'padding-bottom': '48px'});
        $('body').css({'padding-bottom': $('.qty-atc-wrap.sticky').height() })
      }else{
        $('.qty-atc-wrap').removeClass("sticky");
        $('.qty-atc-wrap-spacer').css({'padding-bottom': '0'});
        $('body').css({'padding-bottom': '0' })
      }
    });
  }
  
  /*
  $('.js-cart-trigger').click(function(){
    $('.js-cart-draw').addClass('manual-open');
  });

  $(document).on('click', '.js-cart-draw .js-close-mfp', function(){
    $('.js-cart-draw').removeClass('manual-open');
  });
  
  window.onresize = function() {
    alert(window.innerHeight);
  }
  */  

  $('.js-cart-trigger, .js-product-add').click(function(){
    // alert(screen.height + ' - ' + window.innerHeight + ' - ' + (screen.height - window.innerHeight));
    // $('.upsell_wrap h4').text(screen.height + ' 1- ' + window.innerHeight + ' - ' + (screen.height - window.innerHeight));
    if((screen.height - window.innerHeight) > 43){
      $('.js-cart-draw').addClass('justifyfix heightfix');
    }else{
      $('.js-cart-draw').removeClass('heightfix justifyfix');
    }
  });

  
/*
  var agent = navigator.userAgent.toLowerCase();
  if(agent.indexOf('mobile') > -1 && agent.indexOf('crios') > -1){
    alert('Chrome');
  }else{
    alert('Else');
  }
  */
  
  $('.footer__content .accordian .footer-nav__title').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('.footer-nav__items').slideToggle();
  });
  
  if(getUrlParameter('variant') && $('.silos').length > 0){
  	$('.silos label').removeClass('active');
    $('.silos li[data-variant="'+getUrlParameter('variant')+'"] label').addClass('active');
  }
  
  $('.silos label').click(function(){
    $('.silos label').removeClass('active');
    $(this).addClass('active');
    var id = $(this).parents('li').find('input').attr('id');
    $('#productSelect-1-option-0').val(id.replace('option-', '')).change();
  });
  
  
  
  
  
  
  // Collection Filter "OR" condition
  $('.filtersList li em').click(function(){
    var filters = '';
    filters += $(this).parent('li').data('handle');
    if(getUrlParameter('sort_by')){
      	var sort = getUrlParameter('sort_by');
        window.location.href = '/collections/'+$(this).parents('.filtersList').data('collection')+'/'+filters+'/?sort_by='+sort;
    }else{
    	window.location.href = '/collections/'+$(this).parents('.filtersList').data('collection')+'/'+filters;
    }
  });

  // Remove Filter
  $('.filtersList .removeFilter').click(function(){
    var filters = '';
  	$(this).parent('li').removeClass('active');
    if(getUrlParameter('sort_by')){
      	var sort = getUrlParameter('sort_by');
        window.location.href = '/collections/'+$(this).parents('.filtersList').data('collection')+'/?sort_by='+sort;
    }else{
    	window.location.href = '/collections/'+$(this).parents('.filtersList').data('collection');
    }
  });
  
  
  
  // Collection Sort

  // On load state
  if(getUrlParameter('sort_by')){
    var sort = getUrlParameter('sort_by');
  }else{
    var sort = 'manual';
  }
  $('.sortList li').removeClass('active');
  $('.sortList').find('li[data-handle='+sort+']').addClass('active');
  
  
  $('.sortList li').click(function(){
    sort = $(this).data('handle');
    $('#SortBy').val(sort).change();
  });
  
  // Remove Sort
  $('.sortList .removeSort').click(function(){
    var filters = '';
  	$(this).parent('li').removeClass('active');
    if(getUrlParameter('sort_by')){
      	var sort = getUrlParameter('sort_by');
        window.location.href = '/collections/'+$(this).parents('.filtersList').data('collection')+'/?sort_by='+sort;
    }else{
    	window.location.href = '/collections/'+$(this).parents('.filtersList').data('collection');
    }
  });

  
  $('.touchevents .filters, .touchevents .sorts').click(function(){
    $(this).toggleClass('active');
  	$(this).find('ul').slideToggle();
  });
  
  
  
  
  
  if($('#g-recaptcha').length){
    var $newInput = $('<input type="hidden" name="return_to" value="'+getCookie('referrer')+'" />');
    $newInput.insertBefore($('.shopify-challenge__container input[type="submit"]'));
  }
  
  $('.smileTrigger').click(function(e){
    e.preventDefault();
    $(".smile-launcher-frame").contents().find('.launcher-button').trigger('click');
    // $(".smile-panel-frame").attr('src', window.location.href);
    // $(".smile-panel-frame").attr('referrerpolicy', 'unsafe-url');   
    setCookie('referrer', window.location.href, 0.5);
  });
  
  
  /*
  $(".smile-panel-frame").contents().find('.join-program-card').find('a').click(function(){
    alert('HI');
  });
  */
  
  
  

    $('.get_location').click(function(){
      getLocation();
    });
  
    function getLocation() {      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(setPosition);
      }else{
      	$('.get_location').hide();
      }
    }

    function triggerPosition(){
      $('.zipc_zipcode').val(getCookie('detected_zip'));
      $('.zipc_zipfinder_btn input').trigger('click');
    }
  
    function setPosition(position) {
      $.get('https://www.mapquestapi.com/geocoding/v1/reverse?key=7AQAlGAJv1Avx9ei0LzQiTQk4SD7K3Az&location='+position.coords.latitude+'%2C'+position.coords.longitude+'&outFormat=json&thumbMaps=false', function(data){
      // $.get('https://www.mapquestapi.com/geocoding/v1/reverse?key=7AQAlGAJv1Avx9ei0LzQiTQk4SD7K3Az&location=31.6306%2C74.8911304&outFormat=json&thumbMaps=false', function(data){
        // alert('Your Postal Code: '+data.results[0].locations[0].postalCode);
        // alert(data.results[0].locations.length);
        if(data.results[0].locations.length > 0 && data.results[0].locations[0].postalCode){
          setCookie('detected_city', data.results[0].locations[0].adminArea5, 30);
          setCookie('detected_zip', data.results[0].locations[0].postalCode, 30);
          triggerPosition();
        }
      });
    }
  
  
  
  
  
  
  
  //Floating Whatsapp button
  $walink = $('#h5b_whatsapp_chat a');
  $web_link = 'https://web.whatsapp.com/send?text='+window.location.href+'%0A%0A'+$walink.data('message')+'&phone='+$walink.data('number');
  $api_link = 'https://api.whatsapp.com/send?text='+window.location.href+'%0A%0A'+$walink.data('message')+'&phone='+$walink.data('number');

  
  
  if($('html').hasClass('touchevents')){
    $walink.attr("href", $api_link);
  }else if($('html').hasClass('no-touchevents')){
    $walink.attr("href", $web_link);
  }else{
    $walink.attr("href", $api_link);
  }/*
  $('.hero-wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('header.header').removeClass('header--dark header--light');
    $('header.header').addClass('header--'+$('.slick-current').data('text_color'));
  });
  
  $('.hero-wrapper').on('init', function(event, slick, currentSlide, nextSlide){
    $('header.header').removeClass('header--dark header--light');
    $('header.header').addClass('header--'+$('.slick-current').data('text_color'));
  });  
  */
  
  
  
  
  
  $('.faqs h4').click(function(){
    if (!$(this).hasClass('active')){
      	$('.content').slideUp();
      	$('h4').removeClass('active');
      	$(this).parent('li').children('.content').slideToggle();
    	$(this).addClass('active');
    }
    else{
      $(this).removeClass('active');
      $(this).parent('li').children('.content').slideToggle();      
    }
  });
  
  
  // Hero Banner
  $('.v-slick').slick({
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '<span class="arrow-prev"><i class="icon icon--left-t"></i> </span>',
    nextArrow: '<span class="arrow-next"><i class="icon icon--right-t"></i> </span>'
  });

  // Notify me popup dial code
  $('body').on('click','#custom_test',function(){
    setTimeout(function(){
      $(".hulkapp_popup-dropdown .variant-data select[name='dial_code'] option").each(function(){
        var opt_val = $(this).val();
        if( opt_val == '+91' ){
          $(this).attr('selected','selected');    
        }   
      });
    }, 50)
  })
  
  
 // Zip code Validator
  
   
  
  // For variable products  
  $('#productSelect-1-option-0').change(function(){
    setTimeout(function(){
      console.log('Select');
      if(!getCookie('servicable_zone')|| getCookie('servicable_zone') == 0){
        $("[action='/cart/add']").find("[type='submit']").attr('disabled', true);      
      }
    }, 200);
  });
  
  
  // On load check for Zip code
  console.log(getCookie('servicable_zone'));
  if(getCookie('servicable_zone')){
    if(getCookie('detected_city')){
      $('.zip_holder').text('Your location is '+getCookie('chosen_zip')+' ('+getCookie('detected_city')+')');
      $('.zip_holder').text(getCookie('detected_city'));
    }else{
        $('.zip_holder').text(getCookie('chosen_zip'));
    }
    if(getCookie('servicable_zone') != 0){
      enableatc();
    }else{
      disableatc();
    }
  }else{
  	$("[action='/cart/add']").find("[type='submit']").attr('disabled', true);
    // $("[action='/cart/add']").find("[type='submit']").css('cursor', 'not-allowed');
    $("[action='/cart/add']").find("[type='submit']").attr('title', 'Please check availability in your area');
  }
  
  // Hook for changing Zip code
  $('body').on('click', '#zipc_change_zipcode', function () {
  	$('.zipc_availability_msg').removeClass('not_servicable').hide(0, function(){
      $(this).html('');
    });
    $('.zipc_zipfinder_form').show(0, function(){
      	console.log(getCookie('servicable_zone'));
      	if(getCookie('servicable_zone') != 0){
          $('input[name=zipc_zipcode]').val(getCookie('servicable_zone'));
        }
      	$('input[name=zipc_zipcode]').focus();
    });
  });
  
  // Zip code length validation
  $('input[name=zipc_zipcode]').keyup(function(){
    var entered_val = $(this).val();
    if(entered_val.replace(/ /g, '').length < 6){
      $('.zipc_availability_msg').removeClass('not_servicable').show(0, function(){
        $(this).text('Please enter a 6 digit value.');
      });
    }else{
      $('.zipc_availability_msg').removeClass('not_servicable').hide(0, function(){
        $(this).text('');
      });
    }
  });
  
  // Zip code checker
  $('.zipc_zipfinder_btn .btn').click(function(){
    // console.log('Clicked');
	var entered_val = $(this).parents('.zipc_find_zipcode').find('input[name=zipc_zipcode]').val();
    console.log(entered_val);
    if((entered_val == '' || entered_val == undefined)){
      $('input[name=zipc_zipcode]').addClass('error');
      $('input[name=zipc_zipcode]').focus();
      $('.zipc_availability_msg').removeClass('not_servicable').show(0, function(){
        	$(this).text('Please enter a value');
      });
    }else{
      if(getCookie('detected_zip') == entered_val){
        $('.zip_holder').text(getCookie('detected_city'));
      }else{
      	$('.zip_holder').text(entered_val);
      }
      
      setCookie('chosen_zip', entered_val, 30);
      var zipcodes = ['100001', '100002' , '100003', '110000', '170001', '171001', '171002', '171003', '171004', '171005', '171006', '171008', '171009', '171010', '171011', '171012', '171018', '171102', '171201', '171202', '171205', '171206', '171207', '171209', '171219', '171220', '171222', '171301', '171304', '172001', '172034', '172101', '172102', '172201', '173001', '173002', '173004', '173021', '173025', '173030', '173201', '173202', '173205', '173206', '173207', '173208', '173209', '173210', '173211', '173212', '173213', '173214', '173215', '173220', '173223', '173229', '173230', '173234', '173235', '174001', '174003', '174004', '174005', '174012', '174013', '174021', '174023', '174024', '174026', '174027', '174028', '174029', '174030', '174031', '174032', '174033', '174036', '174101', '174103', '174301', '174302', '174303', '174304', '174305', '174306', '174307', '174308', '174309', '174311', '174312', '174314', '174315', '174316', '174317', '174320', '174321', '174503', '174505', '174507', '175001', '175002', '175003', '175004', '175005', '175006', '175007', '175008', '175011', '175013', '175015', '175016', '175017', '175018', '175019', '175021', '175022', '175023', '175024', '175025', '175027', '175030', '175032', '175033', '175036', '175037', '175042', '175046', '175052', '175101', '175102', '175103', '175106', '175121', '175123', '175124', '175125', '175126', '175128', '175129', '175130', '175131', '175136', '175138', '175143', '176001', '176002', '176021', '176022', '176023', '176025', '176026', '176027', '176028', '176031', '176032', '176033', '176036', '176038', '176039', '176040', '176041', '176042', '176043', '176044', '176045', '176047', '176048', '176049', '176051', '176052', '176053', '176056', '176057', '176059', '176061', '176062', '176063', '176064', '176075', '176077', '176081', '176082', '176083', '176085', '176087', '176092', '176095', '176102', '176103', '176107', '176108', '176109', '176110', '176111', '176115', '176125', '176201', '176202', '176204', '176205', '176206', '176208', '176209', '176210', '176211', '176213', '176214', '176215', '176216', '176217', '176218', '176219', '176225', '176301', '176302', '176303', '176304', '176305', '176306', '176309', '176310', '176313', '176314', '176315', '176318', '176324', '176325', '176401', '176402', '177001', '177005', '177006', '177007', '177020', '177024', '177027', '177029', '177033', '177038', '177039', '177040', '177041', '177042', '177044', '177045', '177048', '177101', '177103', '177104', '177107', '177108', '177114', '177117', '177119', '177201', '177202', '177203', '177204', '177205', '177206', '177207', '177208', '177209', '177210', '177211', '177212', '177213', '177220', '177301', '177401', '177501', '177601', '180001', '180002', '180003', '180004', '180005', '180006', '180007', '180009', '180010', '180011', '180012', '180013', '180015', '180016', '180018', '180019', '180020', '181101', '181113', '181121', '181122', '181123', '181124', '181133', '181141', '181143', '181152', '181201', '181205', '181206', '181224', '182101', '182104', '182121', '182122', '182124', '182125', '182126', '182127', '182128', '182141', '182301', '182311', '182312', '182320', '184101', '184102', '184104', '184120', '184121', '184141', '184142', '184143', '184147', '184151', '185203', '190001', '190002', '190004', '190005', '190008', '190010', '190014', '490001', '490002', '490003', '490004', '490005', '490006', '490007', '490009', '490010', '490011', '490012', '490013', '490020', '490021', '490022', '490023', '490024', '490025', '490026', '490027', '490036', '490042', '491001', '491002', '491003', '491004', '491009', '491107', '491222', '491223', '491226', '491227', '491228', '491335', '491336', '491337', '491338', '491340', '491441', '491445', '491661', '491881', '491885', '491995', '493445', '493555', '493558', '493770', '493773', '493776', '494001', '494004', '494221', '494222', '494223', '494333', '494334', '494335', '494336', '494337', '494670', '495001', '495002', '495003', '495004', '495005', '495006', '495009', '495112', '495113', '495115', '495117', '495119', '495220', '495223', '495330', '495334', '495442', '495446', '495447', '495450', '495452', '495454', '495455', '495550', '495555', '495559', '495668', '495671', '495677', '495678', '495682', '495684', '495686', '495687', '495688', '495689', '495692', '495695', '496001', '496004', '496118', '496220', '496331', '496338', '496445', '496661', '497001', '497101', '497226', '497229', '497335', '497339', '497442', '497446', '497447', '497451', '497553', '497555', '737101', '737102', '737116', '737121', '737126', '737128', '737132', '737134', '737135', '737136', '737139', '744101', '744102', '744106', '744107', '744112', '781001', '781002', '781003', '781004', '781005', '781006', '781007', '781008', '781009', '781010', '781011', '781012', '781013', '781014', '781015', '781016', '781017', '781018', '781019', '781020', '781021', '781022', '781023', '781024', '781025', '781026', '781027', '781028', '781029', '781030', '781031', '781032', '781033', '781035', '781036', '781037', '781038', '781039', '781040', '781068', '781101', '781102', '781103', '781104', '781121', '781122', '781123', '781124', '781125', '781128', '781130', '781132', '781134', '781137', '781141', '781150', '781171', '781301', '781302', '781303', '781304', '781305', '781306', '781307', '781308', '781309', '781310', '781311', '781313', '781314', '781315', '781316', '781317', '781318', '781319', '781320', '781325', '781326', '781334', '781335', '781336', '781337', '781338', '781339', '781340', '781341', '781344', '781346', '781347', '781348', '781349', '781351', '781352', '781353', '781354', '781355', '781365', '781366', '781367', '781369', '781370', '781371', '781374', '781375', '781376', '781378', '781380', '781381', '781382', '782001', '782002', '782003', '782101', '782102', '782103', '782104', '782105', '782106', '782108', '782120', '782122', '782123', '782125', '782126', '782135', '782136', '782137', '782138', '782139', '782140', '782141', '782142', '782143', '782144', '782401', '782402', '782403', '782410', '782411', '782412', '782413', '782425', '782426', '782427', '782429', '782435', '782439', '782440', '782441', '782442', '782445', '782446', '782447', '782448', '782460', '782462', '782481', '782482', '782485', '783101', '783120', '783121', '783122', '783124', '783125', '783126', '783127', '783129', '783131', '783132', '783135', '783301', '783302', '783303', '783307', '783310', '783312', '783320', '783321', '783323', '783324', '783325', '783330', '783331', '783336', '783337', '783339', '783345', '783346', '783347', '783348', '783349', '783351', '783360', '783361', '783369', '783370', '783371', '783372', '783376', '783380', '783381', '783382', '783384', '783385', '783389', '783390', '784001', '784002', '784004', '784010', '784025', '784027', '784028', '784115', '784116', '784125', '784145', '784146', '784148', '784150', '784151', '784153', '784154', '784161', '784164', '784165', '784167', '784168', '784174', '784175', '784176', '784177', '784178', '784180', '784182', '784184', '784189', '784501', '784514', '784529', '785001', '785002', '785003', '785004', '785005', '785006', '785007', '785008', '785009', '785010', '785011', '785013', '785014', '785015', '785016', '785101', '785102', '785104', '785105', '785106', '785107', '785110', '785111', '785112', '785113', '785601', '785602', '785603', '785609', '785610', '785612', '785613', '785615', '785616', '785620', '785621', '785622', '785623', '785625', '785626', '785630', '785631', '785634', '785635', '785636', '785638', '785640', '785641', '785643', '785644', '785648', '785649', '785660', '785662', '785663', '785664', '785665', '785666', '785667', '785668', '785669', '785670', '785672', '785673', '785674', '785675', '785676', '785678', '785680', '785681', '785682', '785683', '785684', '785685', '785686', '785687', '785688', '785689', '785690', '785691', '785692', '785694', '785695', '785696', '785697', '785698', '785699', '785700', '785701', '785702', '785704', '785705', '786001', '786002', '786003', '786004', '786005', '786006', '786007', '786008', '786010', '786012', '786101', '786102', '786103', '786121', '786124', '786125', '786126', '786145', '786146', '786147', '786150', '786151', '786152', '786153', '786155', '786156', '786157', '786158', '786159', '786160', '786170', '786171', '786172', '786173', '786174', '786181', '786182', '786183', '786184', '786185', '786187', '786188', '786189', '786190', '786191', '786192', '786602', '786610', '786611', '786612', '786613', '786614', '786621', '786622', '786623', '786692', '787001', '787026', '787029', '787031', '787032', '787034', '787051', '787052', '787053', '787055', '787056', '787057', '787058', '787059', '787060', '787110', '788001', '788002', '788003', '788004', '788005', '788006', '788007', '788009', '788010', '788011', '788013', '788014', '788015', '788026', '788030', '788031', '788098', '788101', '788102', '788103', '788104', '788106', '788107', '788109', '788110', '788111', '788115', '788116', '788117', '788118', '788119', '788121', '788123', '788126', '788150', '788151', '788152', '788155', '788156', '788160', '788161', '788163', '788164', '788167', '788168', '788169', '788701', '788702', '788706', '788709', '788710', '788711', '788712', '788713', '788719', '788720', '788722', '788723', '788724', '788725', '788726', '788727', '788728', '788801', '788802', '788803', '788805', '788806', '788815', '788819', '788830', '790001', '790114', '791001', '791102', '791109', '791110', '791111', '791113', '791120', '791125', '792001', '792056', '792103', '792105', '792110', '792120', '792121', '792123', '792130', '793001', '793002', '793003', '793004', '793005', '793006', '793007', '793008', '793010', '793011', '793014', '793016', '793017', '793018', '793022', '793101', '793102', '793105', '793150', '794001', '794101', '794104', '794105', '794111', '795001', '795002', '795003', '795004', '795005', '795008', '795010', '796001', '796005', '796007', '796008', '796009', '796012', '796081', '796082', '796181', '796186', '796261', '796310', '796321', '796571', '796701', '796891', '796901', '797001', '797103', '797112', '797113', '797115', '797116', '797117', '798601', '799001', '799002', '799003', '799004', '799005', '799006', '799007', '799008', '799009', '799010', '799012', '799013', '799014', '799022', '799035', '799046', '799102', '799103', '799105', '799114', '799115', '799120', '799130', '799142', '799144', '799155', '799201', '799202', '799203', '799204', '799205', '799207', '799210', '799250', '799251', '799253', '799254', '799260', '799263', '799264', '799266', '799277', '799278', '799279', '799280', '799288', '799289', '799290'];
        
      if(jQuery.inArray(entered_val, zipcodes) < 0){ // Find Zip Code condition
        enableatc();      
        setCookie('servicable_zone', entered_val, 30);
        
        if($('.apadd').length > 0){
          $('.apadd').find('.js-product-add').trigger('click');
          $('.apadd').removeClass('apadd');
        }
        
      }else{
        disableatc();      
        setCookie('servicable_zone', 0, 30)
      }
    }
    
  });
                        
  // Direction for Zip Code validation
  /*
  $('.product-single__add').click(function(){
     if(!getCookie('servicable_zone')){
       $('.zipc_zipfinder_form').show(0, function(){	
          $('input[name=zipc_zipcode]').focus();
       });
       $('.zipc_availability_msg').removeClass('not_servicable').show(0, function(){
          $(this).text('Please check the availability in your area.');
       });
     }
  });
  */
  
                        
  // Zip code on Collection page
  $('body').on('click', '.product-item .product-btn, .product-single__add', function(){
     if(!getCookie('servicable_zone')){
       $('.apadd').removeClass('apadd');
       $(this).addClass('apadd');
       
       	 getLocation();
       
       scrolltozipform();
	 }else{
       if(getCookie('servicable_zone') == 0){
         $('.unservicable_notice').fadeIn();
         // $("[action='/cart/add']").find("[type='submit']").css('cursor', 'not-allowed');
       }
     }
  });
      
  // Unservicable area notice
  $('.unservicable_notice a').click(function(e){
    e.preventDefault();
    scrolltozipform();
  });

  // Open Zip Code Validator                 
  $('#zip_hook').click(function(e){
    e.preventDefault();
    $('.zip-validator-wrap').slideToggle();
    $('body').toggleClass('zipvopen');
  });
  
  $('#zip_hook-mobile').click(function(e){
    e.preventDefault();
    $('#zip_hook').trigger('click');
  });

  // Close Zip Code validator in header
  $(body).on('click', function (e){
    
    if(!$(e.target).is('#zipc_change_zipcode') && $(e.target).parents('.secondary-nav__item--zip').length < 1 && $(e.target).parents('.zip-validator-wrap').length < 1){
    	$('.zip-validator-wrap').slideUp();
        $('body').removeClass('zipvopen');
    }
  });
     

  $('body').on('click', '#pincollect', function(){
    var closeBtn = '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp"><i class="icon icon--close"></i></button>';
    $.magnificPopup.open({
      items: {
        src: ".js-pincollect-draw"
      },
      type: "inline",
      mainClass: "mfp-medium",
      fixedContentPos: true,
      focus: ".js-pincollect-input",
      closeMarkup: closeBtn,
      removalDelay: 200
    });
  });

  $('.pincollectform').submit(function(e){
    e.preventDefault();

    $email = $(this).find('input[type="email"]').val();
    $pincode = $(this).find('input.pincode').val();
    $phone = $(this).find('input.phone').val();
    
    $(this).find('button').attr('disabled', true);
    $(this).find('button').addClass('loading');

    $.ajax({
      method: "POST",
      url: "https://html5bakers.com/projects/airtable/submit.php",
      data: { email: $email, pincode: $pincode, phone: $phone }
    }).done(function(response) {
      console.log(response.responseText);
      $('.pincollectformsubmit').removeAttr('disabled');
      $('.pincollectformsubmit').removeClass('loading');
      $('#response').fadeIn(300, function(){
        $('.pincollectform').fadeOut(500);
        $(this).text('Thank you for submitting the form.');
      });
    }).fail(function(response) {
      console.log(response);
      $('.pincollectformsubmit').removeAttr('disabled');
      $('.pincollectformsubmit').removeClass('loading');
      $('#response').fadeIn(300, function(){
      	$(this).text('Something went wrong! Please try again later!');
      });
    });

  });

  
// Zip Code validator functions
                        
  // Disable Add to Cart
  function disableatc(){
    $('body').addClass('disable_atc');
    $('body').removeClass('enable_atc');    
    $("[action='/cart/add']").find("[type='submit']").attr('disabled', true);
    // $("[action='/cart/add']").find("[type='submit']").css('cursor', 'not-allowed');
    $("[action='/cart/add']").find("[type='submit']").attr('title', 'Please check availability in your area');
    
    $('.zipc_availability_msg').addClass('not_servicable').show(0, function(){
      $(this).html('Sorry, we cannot deliver there. Fill this <span id="pincollect">form</span> get notified when your area is servicable. <span id="zipc_change_zipcode">Check another pincode</span>');
    });
    
    $('.zipc_zipfinder_form').hide(0);
  }
  
  // Enable Add to Cart
  function enableatc(){
    $('body').addClass('enable_atc');
    $('body').removeClass('disable_atc');    
    $("[action='/cart/add']").find("[type='submit']").removeAttr('disabled');
    // $("[action='/cart/add']").find("[type='submit']").css('cursor', 'pointer');
    $("[action='/cart/add']").find("[type='submit']").attr('title', 'Add to cart');
    
    $('.zipc_availability_msg').removeClass('not_servicable').show(0, function(){
      $(this).html('Woohoo! This goodness ships your way. <span id="zipc_change_zipcode">Check another pincode</span>');
    });
    
    $('.zipc_zipfinder_form').hide(0);
    $('.unservicable_notice').fadeOut();
  }
  
  function scrolltozipform(){
    $('html, body').animate({ scrollTop: 0 }, 500, function(){      
      $('.zip-validator-wrap').slideDown(200);
      $('body').addClass('zipvopen');
      $('.zip-validator-wrap .zipc_zipfinder_form').show(0, function(){
        // $('input[name=zipc_zipcode]').focus();
        $('input[name=zipc_zipcode]').val(getCookie('chosen_zip'));
        $('.zip-validator-wrap .zipc_availability_msg').hide(0);
        $('body').addClass('zipvopen');
      });
    });
  }                                        
                        
                     
  
  /* Popup */
  // $('.popuphook').click(function(e){
  $(document).on('click', '.popuphook', function(e){
    e.preventDefault();
    var popup = $(this).data('popup');
    $(popup).fadeIn(200, function(){
      $(popup).find('.popup').fadeIn(200);
      $(popup).addClass('visible');
      $('body').addClass('js-drawer-open');
    });
  });
  
  $('.popupWrap .close').click(function(e){
    e.preventDefault();
    $(this).parents('.popup').fadeOut(200, function(){
      $(this).parents('.popupWrap').fadeOut(400).removeClass('visible');
      $('body').removeClass('js-drawer-open');
    });
  });

  $('.popupWrap').click(function(e){
    var target = $(e.target);
    if(target.is('.popupWrap')){
      $(this).find('.popup').fadeOut(200, function(){
        $(this).parents('.popupWrap').fadeOut(400).removeClass('visible');
        $('body').removeClass('js-drawer-open');
      });
    }
  });

});

//Function to send Customer ID to the CRM handler if it exists
function getCRMDetails() {
  var campaignURL;
  
  //Set the CRM cookie
  campaignURL = getUrlParameter('crm');
  if(campaignURL != undefined) {
    eraseCookieFromAllPaths('crm');
  	setCookie('crm', getUrlParameter('crm'), 1);
  }

  if(getCookie('crm')){
    jQuery.post('/cart/update.js', { attributes: {
  	  crmVal: getCookie('crm'),
   }});
  }

} 

function eraseCookieFromAllPaths(name) {
    // This function will attempt to remove a cookie from all paths.
    var pathBits = location.pathname.split('/');
    var pathCurrent = ' path=';

    // do a simple pathless delete first.
    document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';

    for (var i = 0; i < pathBits.length; i++) {
        pathCurrent += ((pathCurrent.substr(-1) != '/') ? '/' : '') + pathBits[i];
        document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + pathCurrent + ';';
    }
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

//Script to take product title name and add it to the body
function applyProductName() {
  if($('#ProductSection-product-template').length) {
    var productName = $('#ProductSection-product-template').attr('data-product-name');
    productName = productName.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, ' ');
    productName = productName.toLowerCase();
    $('body').addClass('body-' + productName);

  }
}

















function initOwlCarousel() {
 
  $(".slick-carousel").slick({ slidesToShow: 1, dots: true, infinite: false, arrows: true, centerPadding: '100px', speed : 700, prevArrow: "<div class='slick-prev'><i class='icon icon--left'></i></div>", nextArrow: "<div class='slick-next'><i class='icon icon--right'></i></div>" });
  
  if($(".usp-carousel").length && $(window).width() < 700) {
    $(".usp-carousel").slick({ slidesToShow: 1, dots: true, infinite: false, arrows: false });
  }
  
  if($(".mad-carousel").length && $(window).width() < 700 ) {
  	$(".mad-carousel").slick({ slidesToShow: 1, dots: true, infinite: false, arrows: false });
  }
  
  if($(".icontext-carousel").length) {
    $(".icontext-carousel").slick({ 
      slidesToShow: 4, 
      slide: '.o-layout__item',
      autoplay: true,
      rows: 0,
      dots: false, 
      infinite: true, 
      arrows: true,
      centerPadding: "10px",
      prevArrow: '<span class="arrow-prev"><i class="icon icon--left-t"></i> </span>',
      nextArrow: '<span class="arrow-next"><i class="icon icon--right-t"></i> </span>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $(window)
  .resize(function() {
    winWidth = $(window).width();
    var thisSlider = $('.js-layout-slider-all');
    thisSlider.not(".slick-initialized").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      slide: '.o-layout__item',
      rows: 0,
      infinite: false,
      dots: true,
      arrows: false,
      centerPadding: "10px",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            infinite: false,
            centerMode: true,
            centerPadding: "30px"
          }
        }
      ]
    });

    thisSlider.on("afterChange", function(event, slick, currentSlide) {
      $(this)
      .find(".slick-current")
      .addClass("js-slide-seen");
      $(this).find('.product-top').removeAttr("style");
    });
  })
  .resize();
  
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

$('body:not(.template-index) #shopify-section-header').css({'padding-top': $('.free-shipping-wrapper').height()+10});

//Function to change the Shipping Bar when there's an AJAX add to cart
function updateShippingBarRate() {
  var target = document.getElementById('CartContainer');

  // create an observer instance
  var cartValue, cartHTML;
  var observer = new MutationObserver(function(mutations) {
  var threshold_standard = 39900/100;  
    
    
      
      cartHTML = '';
      
      if($('#CartContainer .ajaxcart__footer-total .money').html() == undefined){
        cartHTML += "Free shipping* above Rs. "+threshold_standard;
        
      }else {
        cartValue = parseFloat($('#CartContainer .ajaxcart__footer-total .money').html().replace('Rs. ', '').replace(',', ''));
        if (cartValue >= threshold_standard){
          cartHTML += "You have got free shipping! Woohoo!";
          
        }else{
          cartHTML += "Add Rs. " + (threshold_standard - cartValue) + " to your cart to qualify for free shipping*";
          
        }
      }
      
    
    
    $('.free-shipping-wrapper').html(cartHTML);
    
    $('body:not(.template-index) #shopify-section-header').css({'padding-top': $('.free-shipping-wrapper').height()+10});
    

    
    
    
    
    var checkout_text = "Check Out";
    
    $('.ajaxcart__checkout_custom').click(function(){
      console.log('azx');
   		$('.ajaxcart__checkout').trigger('click');
    });
    
    if($('#CartContainer .ajaxcart__footer-total .money').html() != undefined){
    	$('.ajaxcart__checkout_custom').html(checkout_text +' • <span class="money">'+$('#CartContainer .ajaxcart__footer-total .money').html()+'</span>');
    }else{
      	$('.ajaxcart__checkout_custom').html(checkout_text);
    }
    if($('.ajaxcart__savings').length > 0){
    	$('.aj_discount').html($('.ajaxcart__savings').html());
    }else{
    	$('.aj_discount').html('');
    }
    
var offer_notice = "";
    
      
      var max_val = 39900/100;
      var c_val = cartValue;
      var diff = max_val - c_val;
      var percent = 100 - (diff * 100)/max_val;
      if(diff > 0){
        offer_notice = 'Almost there! Add Rs.' + diff + ' to unlock free shipping!';
      }else{
        offer_notice = 'You have got free shipping! Woohoo!';
      }
      
    

    var c_count = $('#CartCount').text();
    if(c_count > 0){
      $('#free-shipping-notice').show();
      $('.offer_notice').html(offer_notice);
      $('.progressbar .progress').css({'width':percent+'%'});
    }else{
      $('.offer_notice').html("Free shipping above Rs." + max_val);
      $('.progressbar .progress').css({'width':'0%'});	
      $('#free-shipping-notice').hide();
    }
    
       
    
    
  });

  // configuration of the observer:
  var config = { attributes: true, childList: true, characterData: true };

  // pass in the target node, as well as the observer options
  observer.observe(target, config);
}


function getParameterByName(name, url) { if (!url) url = window.location.href; name = name.replace(/[\[\]]/g, "\\$&"); var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url); if (!results) return null; if (!results[2]) return ''; return decodeURIComponent(results[2].replace(/\+/g, " ")); }


$(document).on("click", ".post-ship-btn", function () {
  var f_ch = $('.awb_number').val().slice(0, 2).toLowerCase();
  if(f_ch == '41'){
    window.open("https://www.delhivery.com/track/package/"+$('.awb_number').val());
  }else if(f_ch == 'b8'){
    window.open("https://tracking.dtdc.com/ctbs-tracking/customerInterface.tr?submitName=showCITrackingDetails&cType=Consignment&cnNo="+$('.awb_number').val());
  }else{
    window.open("https://tracking.proship.in/"+$('.awb_number').val());
  }
})




